import type { AllCitiesResponse } from './api';

export const normalizeAllCitiesList = (list: AllCitiesResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.cityName,
    value: row.cityName,
  }));
};
